import React from 'react';
import { RedBoxError } from 'redbox-react';
import ErrorStackParser from 'error-stack-parser';
import { withStyles } from '@material-ui/core/styles';
import CardContent from '@material-ui/core/CardContent';

export default
@withStyles({
  redbox: {
    width: '100%',
    color: 'white',
    textAlign: 'left',
    fontSize: 16,
    lineHeight: 1.2,
    overflow: 'auto',
  },
  stack: {
    fontFamily: 'monospace',
  },
  frame: {
    marginTop: '1em',
  },
})
class ErrorBox extends RedBoxError {
  render() {
    // The error is received as a property to initialize state.error, which may
    // be updated when it is mapped to the source map.
    const { classes } = this.props;
    const { error } = this.state;

    try {
      const frames = ErrorStackParser.parse(error);

      return (
        <CardContent className={classes.redbox}>
          <div className={classes.stack}>{this.renderFrames(frames)}</div>
        </CardContent>
      );
    } catch (err) {
      return (
        <CardContent className={classes.redbox}>
          <div className={classes.stack}>
            <div className={classes.frame}>
              <div>
                Failed to parse stack trace. Stack trace information
                unavailable.
              </div>
            </div>
          </div>
        </CardContent>
      );
    }
  }
}
